var map = {
	"./basicsBannerImg.png": 4886,
	"./basicsImg1.png": 83,
	"./basicsImg2.png": 8104,
	"./basicsImg3.png": 6497,
	"./basicsImg4.png": 1934,
	"./basicsImg5.png": 7719,
	"./basicsImg6.png": 684,
	"./fruityBannerImg.png": 9660,
	"./fruityImg1.png": 549,
	"./fruityImg2.png": 3198,
	"./fruityImg3.png": 1511,
	"./specialtyBannerImg.png": 8467,
	"./specialtyImg1.png": 8556,
	"./specialtyImg2.png": 7031,
	"./specialtyImg3.png": 9342,
	"./specialtyImg4.png": 1809,
	"./specialtyImg5.png": 5512,
	"./specialtyImg6.png": 8723,
	"./specialtyImg7.png": 7146,
	"./specialtyImg8.png": 1005,
	"./specialtyImg9.png": 8500
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1966;